import { render, staticRenderFns } from "./SelClub.vue?vue&type=template&id=5fba1646"
import script from "./SelClub.vue?vue&type=script&lang=js"
export * from "./SelClub.vue?vue&type=script&lang=js"
import style0 from "./SelClub.vue?vue&type=style&index=0&id=5fba1646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports